import { Injectable } from '@angular/core';

/** How `setSidebarOpen` stores an open sidebar: `String(true)`. */
const STORED_OPEN = 'true';

export const ViewType = { List: 'LIST', Board: 'BOARD' } as const;
export type ViewType = (typeof ViewType)[keyof typeof ViewType];

@Injectable({ providedIn: 'root' })
export class UiPreferencesService {
  private readonly VIEW_TYPE_PREFERENCE_PREFIX = 'ViewType.';
  private readonly SIDEBAR_OPEN_PREFERENCE_PREFIX = 'Sidebar.open.';

  getViewType(module: ModuleType): ViewType {
    const value = localStorage?.getItem(this.buildKey(module));

    if (value === ViewType.List || value === ViewType.Board) {
      return value;
    }

    return ViewType.List;
  }

  setViewType(module: ModuleType, value: ViewType): void {
    localStorage?.setItem(this.buildKey(module), value);
  }

  getSidebarOpen(cabinet: string): boolean {
    return (
      localStorage?.getItem(`${this.SIDEBAR_OPEN_PREFERENCE_PREFIX}${cabinet}`) === STORED_OPEN
    );
  }

  setSidebarOpen(cabinet: string, value: boolean): void {
    localStorage?.setItem(`${this.SIDEBAR_OPEN_PREFERENCE_PREFIX}${cabinet}`, String(value));
  }

  private buildKey(module: ModuleType): string {
    return `${this.VIEW_TYPE_PREFERENCE_PREFIX}${module}`;
  }
}
export type ModuleType = 'REGISTERED_CARRIERS' | 'NEW_REGISTRATIONS_CARRIERS' | 'LOADS';
